import uploadApi from '@/services/plataforma/upload';
import uploadApiV2 from '@/services/plataforma/contentv2/upload';

export default {
  actionUploadFile({ dispatch }, { file, type, courseId, isInteractiveZip = false, folderName = null }) {
    const fileExtension = file.name.split('.').pop().toLowerCase();
    const fileExtForUpload = `.${isInteractiveZip ? 'interactive-zip' : fileExtension}`;
    const useMediaBucket = type === 'recording';

    return uploadApi
      .getSignature({
        folderName    : folderName || courseId,
        fileExtension : fileExtForUpload,
        useMediaBucket
      })
      .then(({ data: { key, url } }) => {
        return dispatch('actionUploadInS3', { url, file })
          .then(() => {
            const cdnBaseUrl = useMediaBucket ? process.env.S3_CDN_MEDIA_URL : process.env.S3_CDN_URL;
            const cdnUrl = new URL(key, cdnBaseUrl);

            return Promise.resolve({
              url      : cdnUrl.href,
              fileKey  : key,
              fileName : file.name,
              fileSize : file.size
            });
          })
          .catch(() => {
            throw new Error(this.app.i18n.t('taskEditor.uploadError'));
          });
      })
      .catch(e => {
        if (e.response?.data?.error?.message) {
          throw new Error(this.app.i18n.t('taskEditor.uploadErrorMessage') + e.response.data.error.message);
        }
        throw new Error(this.app.i18n.t('taskEditor.uploadError'));
      });
  },
  actionUploadInS3(_, { url, file }) {
    return uploadApi
      .uploadFile(url, file)
      .then(result => {
        return Promise.resolve(result);
      })
      .catch(e => {
        return Promise.reject(e);
      });
  },
  actionGetAnnotationSignatureV2(_, { academicMainId, correctionId, enrollmentTaskAttachmentId, isLegacy }) {
    return uploadApiV2
      .getCorrectionSignature({ academicMainId, correctionId, enrollmentTaskAttachmentId, isLegacy, fileType: 'txt' })
      .then(result => {
        return Promise.resolve(result.data);
      })
      .catch(e => {
        return Promise.reject(e.response);
      });
  },
  actionGetCorrectionSignatureV2(_, { academicMainId, correctionId, enrollmentTaskAttachmentId, isLegacy }) {
    return uploadApiV2
      .getCorrectionSignature({ academicMainId, correctionId, enrollmentTaskAttachmentId, isLegacy, fileType: 'pdf' })
      .then(result => {
        return Promise.resolve(result.data);
      })
      .catch(e => {
        return Promise.reject(e.response);
      });
  },
  actionUploadCorrectionFileInS3(_, { signature, file }) {
    return uploadApi
      .uploadFile(signature.writeSignature.url, file)
      .then(() => {
        return Promise.resolve({
          url: `${process.env.S3_CDN_URL}/${signature.writeSignature.key}`
        });
      })
      .catch(e => {
        return Promise.reject(e);
      });
  }
};
